import { dynamicLoader } from '~/utils';

export const SimpleCompanySelector = dynamicLoader({
  name: 'SimpleCompanySelector',
  importFunc: () => import('./simple-company-selector'),
});